module.exports = __webpack_public_path__ + "static/media/torsten.7f63a644.jpg";